module.exports = __webpack_public_path__ + "img/20.16d688bb.jpg";